<template>
  <div class="orderManagementClass">
      <div class="orderManagementContent">
          <div class="printOrderListBox">
              <div>
                <div class="orderSearchBox">
                  <el-input v-model="name" placeholder="发布人"></el-input>
                  <el-input v-model="circleName" placeholder="圈子"></el-input>
                  <el-select v-model="status" placeholder="状态">
                    <el-option label="待审核" value="EXAMINE"> </el-option>
                    <el-option label="已通过" value="PASS"> </el-option>
                    <el-option label="已拒绝" value="REFUSE"> </el-option>
                  </el-select>
                  <el-button class="searchBtn" @click="search">搜索</el-button>
                  <el-button type="text" class="resetBtn" @click="resetData">
                    <i class="iconfont icon-qingchushujuku"></i>
                    <span>清除条件</span>
                  </el-button>
                </div>
                <div class="orderListTable">
                <div class="tableTool">
                    <div class="toolRight">
                        <el-button type="primary" size="small" :disabled="multipleSelection.length<1" @click="handleDelete"><i
                            class="el-icon-delete"></i>删除
                        </el-button>
                    </div>
                </div>
              <el-table
                :data="tableData"
                border
                style="width: 100%"
                @selection-change="handleSelectionChange"
                class="tableContent"
              >
                <el-table-column
                  type="selection"
                  header-align="center"
                  align="center"
                  width="55"
                >
                </el-table-column>
                <el-table-column
                  prop="name"
                  label="发布人"
                  width="150"
                  header-align="center"
                  show-overflow-tooltip
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="createTime"
                  label="发布时间"
                  header-align="center"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="circleInfo.circleName"
                  label="圈子名称"
                  header-align="center"
                  width="200"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="content"
                  align="center"
                  header-align="center"
                  label="动态内容"
                >
                </el-table-column>
                <el-table-column
                  prop="labelList.label"
                  align="center"
                  header-align="center"
                  label="动态标签"
                >
                    <template slot-scope="scope">
                        <p v-for="(items,index) in scope.row.labelList" :key="index">{{items.label}}</p>
                    </template>
                </el-table-column>
                <el-table-column
                  prop="status"
                  align="center"
                  header-align="center"
                  label="审核状态"
                >
                  <template slot-scope="slot">
                    <p v-if="slot.row.status == 'EXAMINE'">审核中</p>
                    <p v-if="slot.row.status == 'PASS'">已通过</p>
                    <p v-if="slot.row.status == 'REFUSE'">已拒绝</p>
                  </template>
                </el-table-column>
                  <el-table-column
                      prop="likeNum"
                      label="点赞数量"
                      header-align="center"
                      width="80"
                      align="center"
                  >
                  </el-table-column>
                  <el-table-column
                      prop="commentNum"
                      label="评论数量"
                      header-align="center"
                      width="80"
                      align="center"
                  >
                  </el-table-column>
                <el-table-column label="操作" header-align="center" align="center">
                  <template slot-scope="scope">
                    <el-button v-show="scope.row.status=='EXAMINE'"
                      type="text"
                      size="small"
                      @click="toDialog('audit', scope.row)"
                      >审核</el-button
                    >
                    <el-button
                      type="text"
                      size="small"
                      @click="toDialog('view', scope.row)"
                      >查看</el-button
                    >
                    <el-button
                      type="text"
                      size="small"
                      @click="toDialog('delete',scope.row.uuid)"
                      >删除</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                background
                @current-change="handleCurrentChange"
                @prev-click="handleCurrentChange"
                @next-click="handleCurrentChange"
                layout="total,prev, pager, next,jumper"
                :current-page="current"
                :page-size="pageSize"
                :total="total"
                class="pagination"
              >
              </el-pagination>
              <DynamicDialog ref="dynamicDialogRef" @fatherMethod="getList"/>
            </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
    import {dynamicQuery, dynamicDelete, dynamicDeleteList} from "../../utils/interface";
import DynamicDialog from "./dynamicDialog";

export default {
  name: "dynamicAudit",
  components: {
    DynamicDialog,
  },
  data() {
    return {
      name: "",
      circleName: "",
      status: "",
      tableData: [],
      current: 1,
      pageSize: 10,
      total: 0,
        multipleSelection:[],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    search() {
      this.current = 1;
      this.getList();
    },
    //   清除条件
    resetData() {
      this.name = "";
      this.circleName = "";
      this.status = "";
      this.getList();
    },
    // 动态列表获取
    getList() {
      let params = {
          name: this.name,
          circleName: this.circleName,
        status: this.status,
        current: this.current,
        pageSize: this.pageSize,
      };
      dynamicQuery(params).then((res) => {
        this.tableData = res.list;
        this.total = res.total;
      });
    },
    handleCurrentChange(val) {
      this.current = val;
      this.getList();
    },
    toDialog(type, row) {
      if (type == "audit") {
        this.$refs.dynamicDialogRef.init("audit", row);
      } else if (type == "view") {
        this.$refs.dynamicDialogRef.init("view", row);
      } else if (type == "delete") {
        console.log("delete", type, row);
        this.$confirm("确定要删除次动态信息？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          dynamicDelete(row, { uuid:row }).then((res) => {
            if (res.success) {
              this.$message.success("删除成功");
              this.getList();
            } else {
              this.$message.error(res.message);
            }
          });
        });
      }
    },
      handleSelectionChange(val) {
          this.multipleSelection = val
      },
      handleDelete(){
          let uuidArr=[];
          this.multipleSelection.map((item) => {
              uuidArr.push(item.uuid);
          });
          this.$confirm('确定要删除吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).then(() => {
              dynamicDeleteList(uuidArr).then((res)=>{
                  if(res.success){
                      this.$message({
                          type: 'success',
                          message: '删除成功!'
                      });
                      this.getList();
                  } else {
                      this.$message({
                          type: 'waring',
                          message: res.message
                      });
                  }
              });
          }).catch(() => {})
      },
  },
};
</script>

<style lang="less" scoped>
    .orderManagementClass {
        position: relative;
        width: 100%;
        padding: 0 20px 20px;
        .orderManagementContent {
            background: #fff;
            .printOrderListBox {
                padding: 20px;
                .orderSearchBox {
                    display: flex;
                    flex-wrap: wrap;

                    /deep/ .el-input {
                        width: initial;
                        margin-bottom: 22px;
                        margin-right: 30px;
                    }

                    /deep/ .el-input__inner {
                        width: 242px;
                        height: 35px;
                        min-height: 35px;
                        font-size: 12px;
                        color: #999999;
                        background-color: #f2f4f7;
                        border: 1px solid #f2f4f7;
                        border-radius: 5px;

                        &:hover,
                        &:focus {
                            background-color: #fff;
                            border: 1px solid #108ee9;
                        }
                    }

                    /deep/ .el-input__prefix {
                        top: -3px;
                    }

                    /deep/ .el-input__suffix {
                        top: 2px;
                    }

                    /deep/ .el-button {
                        display: block;
                        line-height: 35px;
                        padding: 0;
                        height: 35px;
                    }

                    .searchBtn {
                        width: 82px;
                        background: #3d7fff;
                        border: none;
                        border-radius: 15px;
                        font-size: 14px;
                        color: #ffffff;
                    }

                    .resetBtn {
                        color: #333333;
                    }
                }

                .tableContent {
                    min-height: 650px;

                    /deep/ .el-table__header {
                        tr {
                            th {
                                border-right: none;
                            }
                        }

                        /deep/ .el-table__cell {
                            padding: 5px 0;
                            background: #f2f5fc;
                        }
                    }

                    /deep/ .el-table__body {
                        img {
                            vertical-align: middle;
                            width: 52px;
                            height: 50px;
                        }
                    }
                }

                .pagination {
                    margin-top: 20px;
                    text-align: right;
                }
            }
        }
        .tableTool {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            margin-bottom: 20px;
            .toolRight {
                button {
                    width: 83px;
                    height: 30px;
                    background: rgba(21, 126, 251, 1);
                    border: none;
                    border-radius: 15px;
                    font-size: 13px;
                    color: #fff;

                    i {
                        padding-right: 5px;
                    }

                    &:hover {
                        background: #61a2f0;
                    }
                }
            }
        }
        .dialogBox{
            .details{
                .detailsItem{
                    padding-bottom: 20px;
                    h3{
                        font-weight: 700;
                        font-size: 16px;
                        color: #000;
                        margin-top: 0;
                        letter-spacing: 1px;
                        border-bottom: 1px solid #ddd;
                        padding-bottom: 15px;
                    }
                    .itemContent{
                        display: flex;
                        flex-wrap: wrap;
                        font-size: 15px;
                        padding: 0 30px;
                        .one-row{
                            width: 50%;
                            margin-bottom: 22px;
                            display: flex;
                            .label{
                                padding-right: 15px;
                                min-width: 95px;
                            }
                            .name{
                                color: #000;
                            }
                        }
                        .two-row{
                            width: 100%;
                            margin-bottom: 22px;
                            display: flex;
                            .label{
                                padding-right: 15px;
                                min-width: 95px;
                            }
                            .name{
                                color: #000;
                            }
                        }
                    }
                    .itemPictureContent{
                        display: flex;
                        flex-wrap: wrap;
                        font-size: 15px;
                        padding: 0 30px;
                        justify-content: space-between;
                        .one-row{
                            width: 30%;
                            margin-bottom: 22px;
                            img{
                                width: 100%;
                                height: 138px;
                                border: 1px solid #ddd;
                            }
                            .name{
                                text-align: center;
                                padding-top: 10px;
                                font-size: 14px;
                                display: flex;
                                .label{
                                    min-width: 80px;
                                }
                            }
                        }
                    }
                }
            }
            .audit{
                padding-bottom: 20px;
                h3{
                    font-weight: 700;
                    font-size: 16px;
                    color: #000;
                    margin-top: 0;
                    letter-spacing: 1px;
                    border-bottom: 1px solid #ddd;
                    padding-bottom: 15px;
                }
                .auditContent{
                    padding: 0 30px;
                }
                .cause{
                    display: flex;
                    margin-top: 20px;
                    .causeTitle{
                        min-width: 80px;
                        color: #3a8ee6;
                    }
                    .causeContent{
                        color: #000;
                    }
                }
                .auditEnter{
                    text-align: center;
                    padding-top: 20px;
                    button{
                        width: 120px;
                    }
                }
            }
        }
    }
    .circleContent {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .thumbnailClass{
        width: 200px;
        height: 200px;
        .avatar{
            width: 200px;
            height: 200px;
            border: 1px dashed #ddd;
            border-radius: 4px;
            line-height: 200px;
            font-size: 50px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/dynamic/dynamicAudit.vue